module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-wrapper"
  }, [_c('div', {
    staticClass: "user-panel-wrapper"
  }, [_c('div', {
    staticClass: "user-panel"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.userData.avatar_url,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userData.loginname))])])]), _vm._v(" "), _c('h3', {
    staticClass: "user-title"
  }, [_vm._v("最近创建的话题")]), _vm._v(" "), _c('div', {
    staticClass: "topics-list"
  }, _vm._l((_vm.userData.recent_topics), function(item) {
    return _c('div', {
      staticClass: "user-link",
      on: {
        "click": function($event) {
          _vm.enterDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": item.author.avatar_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.last_reply_at)))])])
  })), _vm._v(" "), _c('h3', {
    staticClass: "user-title"
  }, [_vm._v("最近参与的话题")]), _vm._v(" "), _c('div', {
    staticClass: "replies-list"
  }, _vm._l((_vm.userData.recent_replies), function(item) {
    return _c('div', {
      staticClass: "user-link",
      on: {
        "click": function($event) {
          _vm.enterDetail(item.id)
        }
      }
    }, [_c('div', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": item.author.avatar_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.last_reply_at)))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "create-btn"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.enterCreate
    }
  }, [_vm._v("创建话题")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78856175"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/my.vue
// module id = 50
// module chunks = 0